import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { NormalText } from "components";

const ContainerStyled = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  textAlign: "center",
  position: "relative",
  "& .text-area": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#000000",
    "&.small": {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 300,
    },
    "&.medium": {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
    },
    "&.large": {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
    },
    "& .full-width": {
      width: "100%",
    },
  },
}));

const NoContentFoundUnstyled = ({
  text,
  children,
  isTextFullWidth,
  size = "small", // "small" | "medium" | "large"
  classNames = {},
  className,
}) => {
  const { t } = useTranslation();

  const shouldDisplayChildren = Boolean(children);

  return (
    <ContainerStyled className={className}>
      {shouldDisplayChildren ? (
        <div
          className={clsx(
            "text-area",
            size,
            { "full-width": isTextFullWidth },
            classNames.text
          )}
        >
          {children}
        </div>
      ) : (
        <NormalText
          className={clsx(
            "text-area",
            size,
            { "full-width": isTextFullWidth },
            classNames.text
          )}
        >
          {text ? text : t("Components.NoContent")}
        </NormalText>
      )}
    </ContainerStyled>
  );
};

const NoContentFound = styled(NoContentFoundUnstyled)({});

export default NoContentFound;
